export default __webpack_public_path__ + "static/media/Kanipakam-1.3c22203b.png";